import { useEffect } from 'react'
import Tooltip from '../tooltip'

const SharedLinkEmails = ({ emails }) => {
  const senderName = (id) => {
    let finded = window.appData.users.filter((user) => user.id == id)[0]
    return finded?.name
  }

  return (
    <>
      {emails && emails.length ? (
        <>
          <h4 className="mt-16">{I18n.t('shared-link-recipients-list')}</h4>

          <table className="table table-sm">
            <thead>
              <tr>
                <th>{I18n.t('activerecord.attributes.shared_link.recipients')}</th>
                <th>{I18n.t('activerecord.attributes.shared_link.sender_id')}</th>
                <th>{I18n.t('activerecord.attributes.shared_link.sender_name')}</th>
                <th>{I18n.t('activerecord.attributes.shared_link.sender_email')}</th>
                <th>{I18n.t('activerecord.attributes.shared_link.subject')}</th>
                <th>{I18n.t('activerecord.attributes.shared_link.body')}</th>
                <th>{I18n.t('activerecord.attributes.shared_link.created_at')}</th>
              </tr>
            </thead>
            <tbody>
              {emails.map((email, i) => (
                <tr key={i}>
                  <td>{email.recipients.join(', ')}</td>
                  <td>{senderName(email.sender_id)}</td>
                  <td>{email.sender_name}</td>
                  <td>{email.sender_email}</td>
                  <td>
                    <Tooltip content={email.subject}>
                      <i className="fal fa-sticky-note"></i>
                    </Tooltip>
                  </td>
                  <td>
                    <Tooltip content={email.body}>
                      <i className="fal fa-sticky-note"></i>
                    </Tooltip>
                  </td>
                  <td>{moment(email.created_at).format('L H:mm')}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      ) : null}
    </>
  )
}

export default SharedLinkEmails
